import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button/Button";
import ApplicationForm from "../components/ApplicationForm/ApplicationForm";
import FeatureCardCMTest from "../components/Cards/FeatureCard/FeatureCardCMTest";
import CarouselCemTest from "../components/Carousel/CarouselCemTest";
import "../App.css";

export default function CemTest() {
  const navigate = useNavigate();
  const goToApplication = () => {
    navigate("/cem-test#cemtest-application");
  };

  return (
    <>
      <div className="product" id="cem-test">
        <div className="product-description">
          <h4>Cemtest</h4>
          {/* Информационная система автоматизации лаборатории CMTest */}
          <p className="product-description-header">
            Laboratory Automation Information System CMTest
          </p>
          {/* Информационная система CemTest представляет собой программное обеспечение, разработанное специально для автоматизации процессов в лабораториях, занимающихся тампонажными растворами. <br /><br />
            Цель системы - повышение производительности и обеспечение точности данных, получаемых в ходе лабораторных исследований. */}
          <p>
            The CemTest information system is a software specifically developed
            for automating processes in laboratories dealing with grouting
            solutions. <br />
            <br />
            The system's goal is to increase productivity and ensure accuracy of
            data obtained during laboratory research.
          </p>

          {/* <div className="product__btn-wrapper">
            <Button onClick={goToApplication}>Связаться с нами</Button>
          </div> */}
          {/* Связаться с нами */}
          {/* <div className="product__btn-wrapper">
            <Button onClick={goToApplication}>Contact Us</Button>
          </div> */}
        </div>
        <div className="product-section-wrap">
          {/* Особенности системы */}
          <p className="product-description-header">System Features</p>
          <FeatureCardCMTest />
        </div>
        <div className="product-section-wrap">
          {/* Модули системы */}
          <p className="product-description-header">System Modules</p>
          <div className="product__modules">
            <div className="carousel-wrapper">
              <CarouselCemTest />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="application-form__wrapper" id="cemtest-application">
        <h4>Оставьте заявку</h4>
        <ApplicationForm />
      </div> */}
      {/* Оставьте заявку */}
      {/* <div className="application-form__wrapper" id="cemtest-application">
        <h4>Submit Application</h4>
        <ApplicationForm />
      </div> */}
    </>
  );
}
